import 'css-chunksrc/client/pages/projectPage/timeSheetPage/week/styles.scss';export default {
  "week": "_week_7xbu0_1",
  "day": "_day_7xbu0_8",
  "odd": "_odd_7xbu0_18",
  "today": "_today_7xbu0_21",
  "weekEnd": "_weekEnd_7xbu0_24",
  "name": "_name_7xbu0_28",
  "nbr": "_nbr_7xbu0_36"
};